<div class="user-profile-upload">
  <div class="header-modal mb-0">
    <div class="main-title w-100 mt-0 mb-0">
      <h3>Upload</h3>
    </div>

    <span class="close-dialog" (click)="cancel()">
      <i class="material-icons">close</i>
    </span>
  </div>

  <ngx-dropzone (change)="onUploadProfile($event)"
                [accept]="acceptedFiles"
                [maxFileSize]="5242880"
                [multiple]="false"
                class="dropzone">
    <ngx-dropzone-preview class="dropzone-preview">
      <ngx-dropzone-label>
        <img alt="" src="{{fileUploadIcon}}"/>
        <p class="portal-upload-line">Drag and drop</p>
        <p class="portal-upload-line">Or</p>
        <p class="portal-upload-browse"><span>Browse</span></p>
      </ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>

  <h3 class="upload-section">
    Drag and drop or click to upload a file. Image should be 190x190 and cannot exceed a file size
    Of 1MB. Supported formats are .SVG, .PNG, and .JPG
  </h3>
</div>
